<template>
  <b-row class="TimesheetList mb-2">
    <b-col cols="12" lg="10" offset-lg="1">
      <Notification v-bind.sync="notification" />

      <b-card>
        <b-card-title title-tag="h2" class="text-center">
          APPROVED TIMESHEETS
        </b-card-title>

        <!-- TODO: filter and search -->
        <Datatable
          :resources="resources"
          :options="datatableOptions"
          @update:perPage="updatePerPage"
          @updateSort="updateSort"
          @updatePage="updatePage"
        >
          <template v-slot:cell(num)="data">
            {{ $get(data, 'item.index', 0) + 1 }}
          </template>
          <template v-slot:cell(actions)="scope">
            <span
              v-if="!$get(scope, 'item.code', false)"
              class="text-danger"
            >
              <v-icon name="exclamation-circle" />
              No Code
            </span>
            <b-link
              v-else
              :to="{ name: 'timesheet.view', params: { code: $get(scope, 'item.code', '') } }"
            >
              View
            </b-link>
          </template>
        </Datatable>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import Notification from '@/components/Notification';
import Datatable from '@/components/Datatable';
import ResourceService from '@/services/ResourceService';

const resource = new ResourceService();

export default {
  name: 'TimesheetList',
  components: {
    Notification,
    Datatable,
  },
  mounted() {
    this.getAllApproved();
  },
  data() {
    return {
      timesheetList: [],
      perPage: 10,
      page: 1,
      total: 0,
      sortBy: null,
      sortDesc: false,
    };
  },
  computed: {
    datatableOptions() {
      return {
        small: true,
        pagination: true,
        dtControl: true,
        fields: this.tableFields || [],
        loading: this.isLoadingRequest,
        trClass: this.rowClass,
        total: this.total,
      };
    },
    tableFields() {
      return [
        {
          key: 'num',
          label: '#',
          class: 'text-center',
        },
        {
          key: 'fullName',
          label: 'Full Name',
        },
        {
          key: 'cutoffPeriod',
          label: 'Cutoff Period',
          class: 'text-center',
        },
        {
          key: 'submitDate',
          label: 'Submit Date',
          formatter: val => this.$fd(val, 'MMM DD, YYYY'),
          class: 'text-center',
        },
        {
          key: 'actions',
          label: 'Actions',
          class: 'text-center',
        },
      ];
    },
    resources() {
      return (this.timesheetList || []).map((ts) => {
        const otherData = {};
        const code = this.$get(ts, 'code', '');
        if (!code) {
          otherData.noCode = true;
        }
        return Object.assign({}, ts, otherData);
      });
    },
    ...mapGetters([
      'isApprover',
      'userData',
      'isLoadingRequest',
    ]),
    ...mapState(['notification']),
  },
  methods: {
    getAllApproved() {
      this.startLoadingRequest();
      this.startLoadingPage();

      const params = {
        page: this.page,
        perPage: this.perPage,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
      };

      // fetch all timesheets for approval of user
      resource.get('/timesheet/all-approved', params)
        .then(({
          success,
          data,
          message,
          total,
        }) => {
          if (!success) {
            return this.setNotification({
              show: true,
              dismissible: true,
              variant: 'danger',
              message: message || 'An error occurred',
              icon: { name: 'exclamation-triangle' },
            });
          }
          this.timesheetList = data;
          this.total = total;

          return success;
        })
        .catch(() => {
          this.setNotification({
            show: true,
            dismissible: true,
            variant: 'danger',
            message: 'An error occurred',
            icon: { name: 'exclamation-triangle' },
          });
        })
        .then(() => {
          this.stopLoadingRequest();
          this.stopLoadingPage();
        });
    },
    updatePerPage(val) {
      this.perPage = val;
      this.getAllApproved();
    },
    updateSort(payload) {
      this.sortBy = this.$get(payload, 'sortBy', null);
      this.sortDesc = this.$get(payload, 'sortDesc', false);
      this.getAllApproved();
    },
    updatePage(val) {
      this.page = val;
      this.getAllApproved();
    },
    ...mapActions([
      'startLoadingRequest',
      'stopLoadingRequest',
      'startLoadingPage',
      'stopLoadingPage',
    ]),
  },
};
</script>
